import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlineArrowRightIcon, OutlineBellAlertsIcon } from '@tempmee/react-icons';
import { NotificationLayout } from '../Layout';
import { useReminder } from './hooks/useReminder';
import history from '../../../../browserHistory';

export const ReminderList = () => {
  const { reminders, totalReminders } = useReminder();

  if (totalReminders === 0) return null;

  return (
    <NotificationLayout Icon={OutlineBellAlertsIcon} title={`Reminders (${totalReminders})`}>
      {reminders.map(({ title, description, isVisible, redirectTo }, index) => {
        if (!isVisible) return null;

        const isLast = index === totalReminders - 1;

        const onRedirect = () => history.push(redirectTo);

        return (
          <Row
            key={title}
            justify="between"
            gap={2}
            style={{
              borderBottom: !isLast ? `1px solid ${colors.neutral[100]}` : 'none',
              padding: 16,
            }}
          >
            <button
              type="button"
              style={{
                background: 'none',
                textAlign: 'left',
                width: '80%',
              }}
              onClick={onRedirect}
            >
              <Typography bold color={colors.neutral[600]} style={{ lineHeight: '22px' }}>
                {title}: {description}
              </Typography>
            </button>

            <button
              type="button"
              style={{
                background: 'none',
              }}
              onClick={onRedirect}
            >
              <OutlineArrowRightIcon color={colors.secondary[500]} />
            </button>
          </Row>
        );
      })}
    </NotificationLayout>
  );
};
